// extracted by mini-css-extract-plugin
export default {"optionButton":"option-button_optionButton__I9gkC","small":"option-button_small__Mtd3U"};